//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {rsaEncryFn} from "@/utils/commons";

export default {
  name: "login",
  data() {
    return {
      username: '',
      password: '',
      mobile: null,
      captcha: '',
      loginWay: 'userName',
      msgText: '发送验证码',
      imageCode: '',
      sendBol: true,
      fwWechatId: '',
      qyWechatId: '',
      requestId: '',
      imgSrc: '',
      showLogin: false,
    }
  },
  mounted() {
    this.getImgCode();
    if (this.$route.query.fwOpenId) {
      this.fwWechatId = this.$route.query.fwOpenId;
    }
    if (this.$route.query.qyOpenId) {
      this.qyWechatId = this.$route.query.qyOpenId;
    }
    if (this.$route.query.Authorization) {
      this.showLogin = true;
      let suf = this.$route.query.Authorization;
      localStorage.setItem('_token', "Bearer " + suf);
      this.getCurrent();
      if (this.$route.query.requestId) {
        this.requestId = this.$route.query.requestId;
        this.$router.replace(`/workflow/${this.requestId}`);
      } else {
        if (this.$route.meta.driver) {
          this.$router.replace({path: '/driver/my-delivery'});
        } else {
          this.$router.replace({path: '/'});
          debugger;
        }
      }
    }
  },
  methods: {
    changeLoginWay(way) {
      this.loginWay = way;
    },
    getImgCode() {
      this.imgSrc = process.env.API_ROOT + 'api/code/image/?' + new Date().getTime();
    },
    //发送验证码
    sendCaptcha() {
      if (!this.mobile) {
        this.$vux.toast.text('请填写手机号码');
        return;
      }
      this.sendBol = false;
      let timer = 60;
      let sendTimer = setInterval(() => {
        timer--;
        this.msgText = timer + 's';
        if (timer <= 0) {
          this.msgText = '发送验证码';
          this.sendBol = true;
          clearInterval(sendTimer);
        }
      }, 1000);
      this.$get('api/sms/login-sms/' + this.mobile).then((res) => {
        this.$vux.toast.text('验证码发送成功');
      }).catch(() => {
        this.msgText = '发送验证码';
        this.sendBol = true;
        clearInterval(sendTimer);
      })
    },
    //  获取当前用户信息
    getCurrent() {
      this.$get('api/person/current').then((data) => {
        this.$store.dispatch('commitChangeType', data.userType);
        this.$store.dispatch('commitChangeUserId', data.id);
        if (this.$store.state.userType == '1') {
          this.$store.dispatch('commitChangeSupId', null);
        } else {
          if (this.$route.meta && this.$route.meta.driver) {
            return;
          }
          this.$get('api/supplier/current-sample').then((res) => {
            this.$store.dispatch('commitChangeSupId', res.id);
          })
        }
      });
    },
    login() {
      let loginObj = {};
      if (this.loginWay === 'userName') {
        if (!this.username) {
          this.$vux.toast.text('请填写登录账号');
          return;
        }
        if (!this.password) {
          this.$vux.toast.text('请填写登录密码');
          return;
        }
        if (this.$store.state.systemConfig.enableSecurityCode) {
          if (!this.imageCode) {
            this.$vux.toast.text('请填写验证码');
            return;
          }
        }
        loginObj = {
          username: this.username,
          password: this.password,
          fwOpenid: this.fwWechatId || null,
          qyOpenid: this.qyWechatId || null,
          imageCode: this.imageCode,
          rememberMe: true,
          loginBindingParameters: {}
        };
      }
      if (this.loginWay === 'phone') {
        if (!this.mobile) {
          this.$vux.toast.text('请填写手机号码');
          return;
        }
        if (!this.captcha) {
          this.$vux.toast.text('请填写手机验证码');
          return;
        }
        loginObj = {
          username: this.mobile,
          password: this.captcha,
          fwOpenid: this.fwWechatId || null,
          qyOpenid: this.qyWechatId || null,
          rememberMe: true,
          loginType: "MOBILE_SMS_CODE"
        };
      }
      this.$loadingShow();
      if (loginObj.password) {
        loginObj.password = rsaEncryFn(loginObj.password);
      }
      this.$post('api/login?_allow_anonymous=true', loginObj).then((result) => {
        this.$loadingHide();
        if (result != null && ['errorUsername', 'passwordExpired', 'notActivated', 'invalid', 'firstUpdatePassword', 'error'].includes(result.status)) {
          if (['passwordExpired', 'firstUpdatePassword'].includes(result.status)) {
            this.$vux.toast.text(result.errorMessage || '请前往PC端修改密码！');
          }
          if (['notActivated', 'error', 'invalid', 'errorUsername'].includes(result.status)) {
            if (result.status === 'errorUsername') {
              this.$vux.toast.text('手机号或验证码错误');
            }
            if (result.errorMessage === 'already lock and unlock at') {
              let msg = result.errorMessage;
              msg = msg + result.userDto.unLockTime;
              this.$vux.toast.text(msg);
            } else {
              this.$vux.toast.text(result.errorMessage || result.msg);
            }
          }
          return
        }
        localStorage.setItem('_token', "Bearer " + result.token);
        console.log(result);
        this.getCurrent();
        this.isDriver();
        if (this.$route.meta && this.$route.meta.driver) {
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
          } else {
            this.$router.push('/driver/my-delivery');
          }
        } else {
          this.$router.push('/');
        }
      }).catch(() => {
        this.$loadingHide();
      })
    },
    //  跳转到司机注册页
    registerDriver() {
      if (this.$route.query.redirect) {
        console.log(this.$route.query.redirect);
        this.$router.push({
          path: '/driver/register',
          query: {redirect: this.$route.query.redirect}
        })
      } else {
        this.$router.push('/driver/register');
      }
    },
    //  判断是否为司机角色
    isDriver() {
      this.$get('api/user/current').then((res) => {
        let driverBol = false;
        if (res.roles) {
          res.roles.forEach((item) => {
            if (item.name === 'ROLE_DRIVER_SUP') {
              driverBol = true;
            }
          })
        }
        if (this.$route.meta && this.$route.meta.driver && !driverBol) {
          this.$vux.toast.text('当前登录人员非司机，请通过SRM平台入口访问系统');
        }
        if (!(this.$route.meta && this.$route.meta.driver) && driverBol) {
          this.$vux.toast.text('当前登录人员为司机，请通过司机端入口访问系统');
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/user/login.vue